import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContractForm from '../../../widgets/makeContractSubProject/ContractForm'
import { getContractSubProject, getContractSubProjectNew } from '../../../redux/actions/contract'
export default function SubProjectContractNew() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const type = location.search.substring(1)

  useEffect(() => {
    // if (projectId) {
    handleGetSchema()
    // }
  }, [projectId])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getContractSubProjectNew(projectId)
      //let response = mock
      // if (type == '1') {
      //   response.disabled = true
      // }

      setSchema(response)
    } catch (e) {
      // console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isSubProject>
        <ContentHeader isNotCallApi header={schema?.header} subHeader={schema?.subHeader} />

        {schema?.forms?.forms && (
          <>
            <ContractForm schema={schema.forms.forms} disabled={schema.forms.forms.disabled} />
          </>
        )}
      </SidebarProposal>
    </>
  )
}

const mock = {
  header: 'พิมพ์สัญญา/แนบสัญญาที่ลงนามแล้ว',
  subHeader: 'ข้อเสนอโครงการ การผลิตและบริโภคผักปลอดสารเคมีในครัวเรือน',
  projecCode: '66-00006-02',
  projecName: 'การผลิตและบริโภคผักปลอดสารเคมีในครัวเรือน',
  disabled: false,
  formTemplate: 0,
  forms: {
    forms: {
      disabled: false,
      panelText: 'การทำสัญญา',
      buttonText: 'การทำสัญญา',
      contractType: {
        name: 'contractType',
        label: 'ประเภทการทำสัญญา',
        value: '0',
        valueDef: 'แบบกระดาษ',
        options: [
          {
            value: '0',
            label: 'แบบกระดาษ',
          },
          {
            value: '1',
            label: 'แบบอิเล็กทรอนิกส์',
          },
        ],
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณาระบุ คำนำหน้าชื่อ',
          },
        ],
      },
      funder: {
        name: 'funder',
        label: 'ผู้ให้ทุน',
        value: 'นายใจดี ผู้ให้ทุน',
      },
      recipient: {
        name: 'recipient',
        label: 'ผู้รับทุน',
        value: 'นายดีใจ ที่ได้ทุน',
      },
      witness: {
        inputForm: {
          preName: {
            name: 'preName',
            label: 'คำนำหน้าชื่อ',
            value: '',
            options: [
              {
                value: '0',
                label: 'นาย',
              },
              {
                value: '1',
                label: 'นาง',
              },
            ],
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณาระบุ คำนำหน้าชื่อ',
              },
            ],
          },
          firstName: {
            name: 'firstName',
            label: 'ชื่อ',
            value: '',
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณากรอก ชื่อ',
              },
            ],
          },
          lastName: {
            name: 'lastName',
            label: 'นามสกุล',
            value: '',
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณากรอก นามสกุล',
              },
            ],
          },
        },
        value: [
          {
            id: '',
            header: 'พยานฝั่งผู้ให้ทุน',
            preNameId: '0',
            preName: 'นาย',
            firstName: 'พยาน',
            lastName: 'คนที่1',
          },
          {
            id: '',
            header: 'พยานฝั่งผู้รับทุน',
            preNameId: '0',
            preName: 'นาย',
            firstName: 'พยาน',
            lastName: 'คนที่2',
          },
          {
            id: '',
            header: 'พยานฝั่งผู้รับทุน',
            preNameId: '0',
            preName: 'นาย',
            firstName: 'พยาน',
            lastName: 'คนที่3',
          },
        ],
      },
      contractSignAtt: {
        header: 'แนบสัญญาที่ลงนามแล้ว',
        disabled: false,
        panelText: 'บันทึกดแนบสัญญาที่ลงนามแล้ว',
        attachment: {
          name: 'attachment',
          label: 'แนบไฟล์สัญญาที่ลงนามแล้ว',
          value: {
            label: 'preview_PDF.pdf',
            name: 'preview_PDF.pdf',
            path: 'subproject/contract/95694583-4FD0-44E5-B6CD-64A5D9D515E5.pdf',
            type: 'PDF',
            size: 0,
            id: '149E0EFC-A1FA-45C7-A31B-16A91283BFB4',
          },
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณาแนบไฟล์ สัญญาที่ลงนามแล้ว',
            },
          ],
        },
      },
    },
  },
}
